import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900 mb-6">{aboutData.title}</h2>
        <div className="text-sm md:text-base text-foreground-700 leading-relaxed space-y-4">
          {aboutData.content.split('\n\n').map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </div>
      </div>
    </section>
  );
}